import React, { useState,useEffect } from "react";
// import Input from '../../Components/Atoms/Input/Input'
import {
  CalendarInput,
  FormDropdown,
  FormField,
  FormFieldMail,
  FormTextArea,
} from "../../Components/Molecules/FormField/FormField";
import { useFormik } from "formik";
import * as Yup from "yup";
import Card from "../../Components/Atoms/Card/Card";
import ErrorLabel from "../../Components/Atoms/ErrorLabel/ErrorLabel";
import thosuandSeparator from "../../Helpers/thousandSeparator";
import {
  CancelButton,
  PrimaryButton,
} from "../../Components/Atoms/Button/Button";
import RadioButton from "../../Components/Atoms/RadioButton/RadioButton";
import { SingleDatePicker } from "../../Components/Atoms/SingleDatePicker/SingleDatePicker";
import styles from "./LoanForm.module.scss";
import HBar from "../../Components/Bars/Bars";
import { useParams,useLocation } from 'react-router-dom';
import {getLoanApplicationDetailsApi,get_user_details, get_master_data,updateLoanApplication} from "../../Enums/api_constunts"
import { postMethod } from "../../Helpers/services";
import _ from "lodash"
import { showToast } from "../../Components/Atoms/ToastNotifier/ToastNotifier";
import SpeedometerComponent from "./SpeedometerComponent"

export const SenpComponent = ({ formik, HBarLabel,loanFormDetails,setTotalOtherIncome }) => {
   

      function getLastFiveFinancialYears() {
        const currentYear = new Date().getFullYear();
        
        // The current financial year starts in April
        const startYear = new Date().getMonth() >= 3 ? currentYear : currentYear - 1;
        
        let financialYears = [];
      
        for (let i = 0; i < 5; i++) {
          const start = startYear - i;
          const end = start + 1;
          financialYears.push({"id":i+1, "label":`${start}-${end}`});
        }
      
        return financialYears;
      }
      const lastYearOptions = getLastFiveFinancialYears()
      /* [
        {
          id: 1,
          label: "2022-2023",
        },
        {
          id: 2,
          label: "2021-2022",
        },
        {
          id: 3,
          label: "2020-2021",
        },
        {
          id: 4,
          label: "2019-2020",
        },
      ];
      */
      
    const [other_income_list, setIncomeFields] = useState([
    { incomeType: "", amount: "" },
  ]);

  const otherIncomeOptions = [
    {
      id: true,
      label: "Yes",
    },
    {
      id: false,
      label: "No",
    },
  ];
  const [otherIncomeTypeOptions, setOtherIncomeTypeOptions] =useState([])
  const getMasterData = (category='')=>{
    let postData = {"categories":["md_other_income_types"]};
    
    //values["tenant_id"] = _.get(selectedTenant,"id");
     postMethod(get_master_data,postData).then((res)=>{
      if(category=="md_other_income_types"){   
        setOtherIncomeTypeOptions( _.get(res,"result.md_other_income_types",[]).map((item)=>{ item["label"] =  item["name"];return item}))
      }
        
      })
  }
  const handleAddIncomeField = () => {
    setIncomeFields([...other_income_list, { incomeType: "", amount: "" }]);
  };

  const handleRemoveIncomeField = (index) => {
    const updatedFields = other_income_list.filter((_, i) => i !== index);
    setIncomeFields(updatedFields);
  };

  const handleFieldChange = (index, field, value) => {
    const updatedFields = other_income_list.map((item, i) =>
      i === index ? { ...item, [field]: value } : item
    );
    setIncomeFields(updatedFields);
    formik.setFieldValue(`other_income_list[${index}].${field}`, value);
  };


  const updateTotalOtherIncomeAmount = ()=>{
    console.log(JSON.stringify(formik.values))
    let amount = 0;
   
    other_income_list.forEach((item)=>{
      console.log(_.get(item,"incomeType",""))
      if(_.get(item,"amount",0) && _.get(item,"incomeType","").trim() !='' ){
        
        amount =amount+parseInt(item["amount"])
      } })
  
     setTotalOtherIncome(amount)    
     formik.setFieldValue("total_other_income_per_month",amount)


  }

  const defaultValues = ()=>{
    if(_.has(loanFormDetails, "companyName")){      
      formik.setFieldValue("companyName", loanFormDetails["companyName"])
    }
    if(_.has(loanFormDetails, "designation")){      
      formik.setFieldValue("designation", loanFormDetails["designation"])
    }
    if(_.has(loanFormDetails, "number_of_years")){      
      formik.setFieldValue("number_of_years", loanFormDetails["number_of_years"])
    }
    if(_.has(loanFormDetails, "location")){      
      formik.setFieldValue("location", loanFormDetails["location"])
    }
    if(_.has(loanFormDetails, "last_turnover_year")){      
      formik.setFieldValue("last_turnover_year", loanFormDetails["last_turnover_year"])
      formik.setFieldValue("last_year_itr", loanFormDetails["last_turnover_year"])
    }
    if(_.has(loanFormDetails, "last_year_turnover_amount")){      
      formik.setFieldValue("last_year_turnover_amount", loanFormDetails["last_year_turnover_amount"])
    }
    // if(_.has(loanFormDetails, "last_year_itr")){      
    //   formik.setFieldValue("last_year_itr", loanFormDetails["last_year_itr"])
    // }
    if(_.has(loanFormDetails, "lastYearITRamount")){      
      formik.setFieldValue("lastYearITRamount", loanFormDetails["lastYearITRamount"])
    }
    if(_.has(loanFormDetails, "current_turnover_year")){      
      formik.setFieldValue("current_turnover_year", loanFormDetails["current_turnover_year"])
    }
    if(_.has(loanFormDetails, "current_year_turnover_amount")){      
      formik.setFieldValue("current_year_turnover_amount", loanFormDetails["current_year_turnover_amount"])
    }
    if(_.has(loanFormDetails, "current_year_itr")){      
      formik.setFieldValue("current_year_itr", loanFormDetails["current_year_itr"])
    }
    if(_.has(loanFormDetails, "presentYearITRamount")){      
      formik.setFieldValue("presentYearITRamount", loanFormDetails["presentYearITRamount"])
    }
    if(_.has(loanFormDetails, "avg_income_per_month")){      
      formik.setFieldValue("avg_income_per_month", loanFormDetails["avg_income_per_month"])
    }

    if(_.get(loanFormDetails, "other_income_list")){
      try{
        //otherIncome
        const dbother_income_list = JSON.parse(loanFormDetails["other_income_list"]);
        
        if(_.get(dbother_income_list,"length")>0){
          

          
          let items = []
          /*{ incomeType: "", amount: "" }*/
          let amount =0
          dbother_income_list.forEach((item,index)=>{
            
            formik.setFieldValue(`other_income_list[${index}].incomeType`, item["incomeType"]);
            formik.setFieldValue(`other_income_list[${index}].amount`, item["amount"]); 
            //formik.values["other_income_lis"][index]["incomeType"] = item["incomeType"]
            items.push(item)
            amount =amount+item["amount"]
          });          
          setIncomeFields(items)
          setTotalOtherIncome(amount);

        }else{
          setIncomeFields([ { incomeType: "", amount: "" }])
        }
        
        
      }catch(error){
        setIncomeFields([ { incomeType: "", amount: "" }])
      }
      
    }
    //setIncomeFields
    //designation number_of_years location 
    //last_turnover_year,last_year_turnover_amount,last_year_itr lastYearITRamount 
   //  current_turnover_year  current_year_turnover_amount current_year_itr presentYearITRamount
  //avg_income_per_month 
  }

  useEffect(()=>{
    defaultValues()
    getMasterData("md_other_income_types")
  },[loanFormDetails]);

  return (
    <div>
      {HBarLabel && <HBar label={HBarLabel} />}

      <div className="row">
        <div className="col-md-4 mb-2">
          <FormField
            label="Company Name"
            id="companyName"
            name="companyName"
            type="text"
            value={formik?.values?.companyName}
            onChange={(e) =>
              formik.setFieldValue("companyName", e.target.value)
            }
            error={formik.touched.companyName && formik.errors.companyName}
            disableNumbers={true}
            disableSymbols={true}
            isImportant={true}
            onBlur={formik.handleBlur}
          />
          {formik.touched.companyName && (
            <ErrorLabel
              name="companyName"
              formik={formik}
              message={formik.errors.companyName}
            />
          )}
        </div>
        <div className="col-md-4 mb-2">
          <FormField
            label="Designation"
            id="designation"
            name="designation"
            type="text"
            value={formik?.values?.designation}
            onChange={(e) =>
              formik.setFieldValue("designation", e.target.value)
            }
            error={formik.touched.designation && formik.errors.designation}
            disableNumbers={true}
            disableSymbols={true}
            isImportant={true}
            onBlur={formik.handleBlur}
          />
          {formik.touched.designation && (
            <ErrorLabel
              name="designation"
              formik={formik}
              message={formik.errors.designation}
            />
          )}
        </div>
        <div className="col-md-4 mb-2">
          <FormField
            label="No of years"
            id="number_of_years"
            name="number_of_years"
            type="text"
            value={formik?.values?.number_of_years}
            onChange={(e) => formik.setFieldValue("number_of_years", e.target.value)}
            error={formik.touched.number_of_years && formik.errors.number_of_years}
            disableNumbers={false}
            disableSymbols={true}
            isImportant={true}
            onBlur={formik.handleBlur}
          />
          {formik.touched.number_of_years && (
            <ErrorLabel
              name="number_of_years"
              formik={formik}
              message={formik.errors.number_of_years}
            />
          )}
        </div>
        <div className="col-md-4 mb-2">
          <FormField
            label="Location"
            id="location"
            name="location"
            type="text"
            value={formik?.values?.location}
            onChange={(e) => formik.setFieldValue("location", e.target.value)}
            error={formik.touched.location && formik.errors.location}
            disableNumbers={true}
            disableSymbols={true}
            isImportant={true}
            onBlur={formik.handleBlur}
          />
          {formik.touched.location && (
            <ErrorLabel
              name="location"
              formik={formik}
              message={formik.errors.location}
            />
          )}
        </div>
        <div className="col-md-4 mb-2">
          <FormDropdown
            label="Last Year Turn Over"
            id="last_turnover_year"
            name="last_turnover_year"
            options={lastYearOptions}
            onChange={(selected) =>{
              formik.setFieldValue("last_turnover_year", selected?.label)
              formik.setFieldValue("last_year_itr", selected?.label)
            }
            }
            value={formik?.values?.last_turnover_year}
            error={formik.touched.last_turnover_year && formik.errors.last_turnover_year}
            onBlur={formik.handleBlur}
            isImportant={true}
          />
          {formik.touched.last_turnover_year && (
            <ErrorLabel
              name="last_turnover_year"
              formik={formik}
              message={formik.errors.last_turnover_year}
            />
          )}
        </div>
        {/* last year turn over amount and ITR fields */}
        <div className="col-md-4 mb-2">
          <FormField
            label="Last Year Turn Over Amount"
            id="last_year_turnover_amount"
            name="last_year_turnover_amount"
            type="text"
            value={formik.values.last_year_turnover_amount}
            onChange={(e) =>{formik.setFieldValue("last_year_turnover_amount", e.target.value);
              
            }}
            error={
              formik.touched.last_year_turnover_amount && formik.errors.last_year_turnover_amount
            }
            disableNumbers={false}
            disableSymbols={false}
            isImportant={true}
            onBlur={formik.handleBlur}
          />
          {formik.touched.last_year_turnover_amount && (
            <ErrorLabel
              name="last_year_turnover_amount"
              formik={formik}
              message={formik.errors.last_year_turnover_amount}
            />
          )}
        </div>
        <div className="col-md-4 mb-2">
          <FormDropdown
            label="last Year Income ITR"
            id="last_year_itr"
            name="last_year_itr"
            options={lastYearOptions}
            onChange={(selected) =>
              formik.setFieldValue("last_year_itr", selected?.label)
            }
            value={formik?.values?.last_year_itr}
            error={
              formik.touched.last_year_itr &&
              formik.errors.last_year_itr
            }
            onBlur={formik.handleBlur}
            isImportant={true}
            readOnly
            disabled={true}
          />
          {formik.touched.last_year_itr && (
            <ErrorLabel
              name="last_year_itr"
              formik={formik}
              message={formik.errors.last_year_itr}
            />
          )}
        </div>
        <div className="col-md-4 mb-2">
          <FormField
            label="Last Year ITR amount"
            id="lastYearITRamount"
            name="lastYearITRamount"
            type="text"
            value={formik.values.lastYearITRamount}
            onChange={(e) =>formik.setFieldValue("lastYearITRamount", e.target.value)}
            error={
              formik.touched.lastYearITRamount &&
              formik.errors.lastYearITRamount
            }
            disableNumbers={false}
            disableSymbols={false}
            isImportant={true}
            onBlur={formik.handleBlur}
          />
          {formik.touched.lastYearITRamount && (
            <ErrorLabel
              name="lastYearITRamount"
              formik={formik}
              message={formik.errors.lastYearITRamount}
            />
          )}
        </div>
        {/* present year turn over amount and ITR fields */}
        <div className="col-md-4 mb-2">
          <FormDropdown
            label="Present year turn over"
            id="current_turnover_year"
            name="current_turnover_year"
            options={lastYearOptions}
            onChange={(selected) =>
              formik.setFieldValue("current_turnover_year", selected?.label)
            }
            value={formik?.values?.current_turnover_year}
            error={
              formik.touched.current_turnover_year &&
              formik.errors.current_turnover_year
            }
            onBlur={formik.handleBlur}
            isImportant={true}
          />
          {formik.touched.current_turnover_year && (
            <ErrorLabel
              name="current_turnover_year"
              formik={formik}
              message={formik.errors.current_turnover_year}
            />
          )}
        </div>
        <div className="col-md-4 mb-2">
          <FormField
            label="Present year turn over Amount"
            id="current_year_turnover_amount"
            name="current_year_turnover_amount"
            type="text"
            value={formik.values.current_year_turnover_amount}
            onChange={(e) =>formik.setFieldValue("current_year_turnover_amount", e.target.value)}
            error={
              formik.touched.current_year_turnover_amount &&
              formik.errors.current_year_turnover_amount
            }
            disableNumbers={false}
            disableSymbols={false}
            isImportant={true}
            onBlur={formik.handleBlur}
          />
          {formik.touched.current_year_turnover_amount && (
            <ErrorLabel
              name="current_year_turnover_amount"
              formik={formik}
              message={formik.errors.current_year_turnover_amount}
            />
          )}
        </div>
        <div className="col-md-4 mb-2">
          <FormDropdown
            label="Present year income ITR"
            id="current_year_itr"
            name="current_year_itr"
            options={lastYearOptions}
            onChange={(selected) =>
              formik.setFieldValue("current_year_itr", selected?.label)
            }
            value={formik?.values?.current_year_itr}
            error={
              formik.touched.current_year_itr &&
              formik.errors.current_year_itr
            }
            onBlur={formik.handleBlur}
            isImportant={true}
          />
          {formik.touched.current_year_itr && (
            <ErrorLabel
              name="current_year_itr"
              formik={formik}
              message={formik.errors.current_year_itr}
            />
          )}
        </div>
        <div className="col-md-4 mb-2">
          <FormField
            label="Present year ITR amount"
            id="presentYearITRamount"
            name="presentYearITRamount"
            type="text"
            value={formik.values.presentYearITRamount}
            onChange={(e) =>formik.setFieldValue("presentYearITRamount", e.target.value)}
            error={
              formik.touched.presentYearITRamount &&
              formik.errors.presentYearITRamount
            }
            disableNumbers={false}
            disableSymbols={false}
            isImportant={true}
            onBlur={formik.handleBlur}
          />
          {formik.touched.presentYearITRamount && (
            <ErrorLabel
              name="presentYearITRamount"
              formik={formik}
              message={formik.errors.presentYearITRamount}
            />
          )}
        </div>
        <div className="col-md-4 mb-2">
          <FormField
            label="Avg Income per month"
            id="avg_income_per_month"
            name="avg_income_per_month"
            type="text"
            value={formik.values.avg_income_per_month}
            onChange={(e) => formik.setFieldValue("avg_income_per_month", e.target.value)}
            error={
              formik.touched.avg_income_per_month &&
              formik.errors.avg_income_per_month
            }
            disableNumbers={false}
            disableSymbols={false}
            isImportant={true}
            onBlur={formik.handleBlur}
          />
        
          {formik.touched.avg_income_per_month && (
            <ErrorLabel
              name="avg_income_per_month"
              formik={formik}
              message={formik.errors.avg_income_per_month}
            />
          )}
        </div>
        
        
        
       
        
      </div>
      
     
      {/* <div className="row">
        <div className="col-md-4 mb-2">
          <FormDropdown
            label="Obligations"
            id="Obligations"
            name="Obligations"
            options={otherIncomeOptions}
            onChange={(selected) => {
              console.log("selected", selected);
              formik.setFieldValue("Obligations", selected?.label);
            }}
            value={formik.values.Obligations}
            error={formik.touched.Obligations && formik.errors.Obligations}
            onBlur={formik.handleBlur}
          />
          <ErrorLabel
            name="Obligations"
            formik={formik}
            message={formik.errors.Obligations}
          />
        </div>
      </div>
      {formik.values.Obligations === "Yes" && ( <div className="row">
      
          <div className="col-md-4 mb-2">
            
            <FormField
              label="Total Obligations per Month"
              id="obligations_per_month"
              name="obligations_per_month"
              onChange={(selected) => {
                console.log("selected", selected);
                formik.setFieldValue("obligations_per_month", selected?.label);
              }}
              value={formik.values.obligations_per_month}
              error={formik.touched.obligations_per_month && formik.errors.obligations_per_month}
              onBlur={formik.handleBlur}
              disableAlphebets={true}
              disableSymbols={true}
              
              readOnly
            />
            <ErrorLabel
              name="obligations"
              formik={formik}
              message={formik.errors.obligations_per_month}
            />
          </div>
       
      </div> )} */}


    </div>
  );
};